// extracted by mini-css-extract-plugin
export default {"queue_details":"callLogs_queue_details__IE4mQ","queue_details_loading":"callLogs_queue_details_loading__UNnuP","queue_loading":"callLogs_queue_loading__od6BN"};